/**
 * Eloria contact information constants
 * Shared across components that need to display or share Eloria's contact details
 */
export const ELORIA_EMAIL = "eloria@mail.eloria.app";
export const ELORIA_PHONE = "+598 97599313";
export const ELORIA_WHATSAPP_NUMBER = "59897599313";
export const ELORIA_WHATSAPP_URL = `https://wa.me/${ELORIA_WHATSAPP_NUMBER}`;

